import axiosInstance from "src/helpers/axiosInstance";


export const changeUserPassword = (props) => onResponse =>  {

    try {
        axiosInstance.post("/users/change-password", {
            old_password: props.data.get("old_password"),
            password: props.data.get("password"),
            confirm_password: props.data.get("confirm_password")
          })
        .then((response) => {
            onResponse(response);
        })
        .catch((err) => {
            onResponse(err.response);
        });
            
    } catch (error) {
        
    }
};
export const setResetPassord = (props) => onResponse => {
    console.log(props);
    try {
        axiosInstance.post("/users/reset-user-password-by-admin" , props.formData)
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};


